import CustomFieldsHelpMdx from "../../help/custom-fields.mdx";

export function CustomFieldsHelpPage() {
  return <CustomFieldsHelpMdx />;
}
